import type { ModuleNav } from '@saas/ui';

export const KNOWLEDGE_ADMIN_ROLES = ['owner', 'admin'];

/**
 * knowledge のメニュー（03 §14.10）。
 * ★ 「まず書いてください」から始めない。既定の入口は「探す」で、貯まったものを引くところから使ってもらう。
 * ★ エキスパート検索と棚卸しは契約から 6 か月経つまで「まだ材料が足りません」を返す（§14.11）。
 *   メニューには出しておき、画面で理由を説明する（急に現れるより分かりやすい）
 */
export const knowledgeNav: ModuleNav = {
  module: 'knowledge',
  items: [
    { label: '探す', to: '/knowledge', icon: 'search', end: true, permission: ['knowledge.search'], description: '社内の記録から。出典と日付つき' },
    { label: '私のメモ', to: '/knowledge/notes', icon: 'edit', permission: ['knowledge.note.own'], description: '1 行でいい。自分の足跡も見られる' },
    { label: 'ナレッジ記事', to: '/knowledge/articles', icon: 'description', permission: ['knowledge.article.read'], description: '手順・判断基準・事例' },
    { label: 'Q&A の候補', to: '/knowledge/qa', icon: 'help', permission: ['knowledge.article.read'], description: '繰り返された質問' },
    { label: 'ナレッジにしませんか', to: '/knowledge/proposals', icon: 'bolt', permission: ['knowledge.article.read'], description: '溜まった記録からの提案' },
    { label: '詳しい人を探す', to: '/knowledge/experts', icon: 'group', permission: ['knowledge.expert.search'], description: '記録から見つける' },
  ],
  admin: [
    { label: '知識の棚卸し', to: '/knowledge/handover', icon: 'swap_horiz', permission: ['knowledge.handover.read'], description: '単独保有の知識と引き継ぎ' },
    { label: '取込の状態', to: '/knowledge/admin/sources', icon: 'inventory', roles: KNOWLEDGE_ADMIN_ROLES, permission: ['knowledge.ingest.manage'], description: '受理・拒否・失敗と理由' },
    { label: 'フォルダの取込設定', to: '/knowledge/admin/folders', icon: 'folder', roles: KNOWLEDGE_ADMIN_ROLES, permission: ['knowledge.ingest.manage'], description: 'どのフォルダを検索に入れるか' },
  ],
};
